import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import ChangePassword from './change-password';
import EditProfile from './edit-profile';
import { TPageNotification, TUser } from '../../../types';

type TAccountContainerProps = {
    notification: TPageNotification;
    user: TUser;
}

export default function AccountContainer({
    notification,
    user,
}: TAccountContainerProps) {
    return (
        <div className="account-container">
            <Route
                path="/account/change-password"
                render={() => (
                    <ChangePassword
                        notification={notification}
                    />
                )}
            />
            <Route
                path="/account/edit-profile"
                render={() =>
                    user.isClient
                        ? (
                            <EditProfile
                                notification={notification}
                                user={user}
                            />
                        ) : <Redirect to="/"/>
                }
            />
        </div>
    );
}
